import Service from "./Service";

export class ExamService extends Service {
    constructor() {
        super();
        this.baseURL = 'exam';
    }
}